import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const PreviousIcon = createSvgIcon(
  <path
    d="M14 8L10 12L14 16"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="transparent"
  />,
  "PreviousIcon"
);
